import { FunctionComponent } from 'react';
import SuccessVideoSupport from './SuccessVideoSupport';
import { useTimeSpentMetric } from '../../hooks';
import { environment } from '../../utils/environment';
import SuccessAudioSupport from './SuccessAudioSupport';

const Success: FunctionComponent = () => {
  const { videoSupportEnabled } = environment;

  useTimeSpentMetric('success');

  return videoSupportEnabled ? (
    <SuccessVideoSupport />
  ) : (
    <SuccessAudioSupport />
  );
};

export default Success;
